export function arrayMove(arr, oldIndex, newIndex) {
	if (newIndex >= arr.length) {
		let k = newIndex - arr.length + 1;

		while (k--) {
			arr.push(undefined);
		}
	}

	arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);

	return arr;
}

export function toArray(obj: object): any[] {
	return Object.keys(obj).map(k => obj[k]);
}

export function isEmpty(arr?: any[]): boolean {
	return !arr || arr.length <= 0;
}



// WEBPACK FOOTER //
// ./src/core/util/ArrayUtils.ts